var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-top"},[_c('div',{staticClass:"chart-name"},[_vm._v(" 按市场主体类型分类的质量服务需求量（单位：个） "),_c('dv-decoration-1',{staticStyle:{"width":"200px","height":"20px"}})],1),_c('dv-capsule-chart',{staticStyle:{"height":"260px"},attrs:{"config":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }